import React, {useEffect} from 'react'
import { Col, Row, Icon } from 'antd'
import { connect } from 'react-redux'
import actions from '../../redux/actions'
import Layout from '../../components/Layout'
import Divider from '../../components/Divider'
import styled from 'styled-components'

const Text = styled.p`
  font-size: 18px;
  line-height: 24.3px;
`

const StyledCol = styled(Col)`
  margin: 1rem 0 !important;
`

const BusinessType = (props) => {

  const value = [
    {id: 20, text: 'ค้าของเก่า / วัตถุโบราณ'},
    {id: 30, text: 'การเงิน / ธนาคาร'},
    {id: 40, text: 'คาสิโน / การพนัน'},
    {id: 60, text: 'สหกรณ์ / มูลนิธิ / สมาคม / สโมสร / วัด / มัสยิด'},
    {id: 70, text: 'สถานบริการตามกฎหมายว่าด้วยสถานบริการ'},
    {id: 80, text: 'แลกเปลี่ยนเงินตราต่างประเทศ'},
    {id: 90, text: 'โรงแรม / ภัตตาคาร'},
    {id: 110, text: 'ประกันภัย / ประกันชีวิต'},
    {id: 120, text: 'ค้าอัญมณี / ทอง'},
    {id: 130, text: 'โอนและรับโอนเงินทั้งภายในและต่างประเทศ'},
    {id: 140, text: 'อสังหาริมทรัพย์'},
    {id: 150, text: 'มหาวิทยาลัย / โรงเรียน/ สถานศึกษา'},
    {id: 155, text: 'นายหน้าจัดหางาน'},
    {id: 160, text: 'ธุรกิจนําเที่ยว/บริษัททัวร์'},
    {id: 170, text: 'อาวุธยุทธภัณฑ์'},
    {id: 180, text: 'อื่นๆ'}
  ]

  useEffect(() => window.scrollTo(0,0));

  const handleClick = (id,value) => {

    console.log(props);
    props.setBusinessType(id,value)

    if(id === 180) {
      props.history.push('/other-business-type')
    } else {
      props.history.goBack()
    }
  }

  return (
    <Layout title={'เลือกประเภทธุรกิจ'} backIcon={true} onClick={() => props.history.goBack()}>
      <h4 style={{marginTop: '2rem', marginBottom: '1rem'}}>กรุณาเลือกประเภทธุรกิจ</h4>
      <Row>
        {
          value.map(element => {
            if(element.id === 180) {
              return (
                <StyledCol key={element.id}>
                  <Row style={{marginBottom: '-.5rem'}}>
                    <Col span={22}>
                      <Text onClick={() => handleClick(element.id,element.text)}>{element.text}</Text>
                    </Col>
                    <Col span={2}>
                      <Icon style={{marginTop: '.4rem'}} type="right"/>
                    </Col>
                  </Row>
                  <Divider floatRight={true}/>
                </StyledCol>
              )
            } else {
              return (
                <StyledCol key={element.id}>
                  <Text onClick={() => handleClick(element.id,element.text)}>{element.text}</Text>
                  <Divider floatRight={true}/>
                </StyledCol>
              )
            }
          })
        }
      </Row>
    </Layout>
  )
}

const mapDispatchToProps = {
  setBusinessType: actions.setBusinessType,
}

const BusinessTypeWithConnect = connect(null, mapDispatchToProps)(BusinessType)

export default BusinessTypeWithConnect
